import { WaveBlockKind } from "@vida/wave-core";
import { blockKindColor } from "./waveFeedTokens";

export type WaveWidgetPickerProps = {
  commandText: string;
  onAddPlainText: () => void;
  onAddAssistant: () => void;
  onPickFile: () => void;
  onInsertBlock: (kind: WaveBlockKind) => void;
};

type WidgetOption = {
  id: string;
  title: string;
  subtitle: string;
  glyph: string;
  kind?: WaveBlockKind;
  action: () => void;
};

export function WaveWidgetPicker({
  commandText,
  onAddPlainText,
  onAddAssistant,
  onPickFile,
  onInsertBlock,
}: WaveWidgetPickerProps) {
  const trimmed = commandText.trim();
  const showDraftActions =
    trimmed.length > 0 &&
    (!trimmed.startsWith("/") ||
      trimmed.toLowerCase().includes("@assistente") ||
      trimmed.toLowerCase().includes("@documenti:"));

  const options: WidgetOption[] = [
    {
      id: "text",
      title: "Testo",
      subtitle: "Messaggio o nota",
      glyph: "T",
      kind: WaveBlockKind.Text,
      action: () => onInsertBlock(WaveBlockKind.Text),
    },
    {
      id: "poll",
      title: "Sondaggio",
      subtitle: "Vota le opzioni",
      glyph: "▣",
      kind: WaveBlockKind.Poll,
      action: () => onInsertBlock(WaveBlockKind.Poll),
    },
    {
      id: "todo-list",
      title: "Lista todo",
      subtitle: "Più azioni collaborative",
      glyph: "☑",
      kind: WaveBlockKind.TodoList,
      action: () => onInsertBlock(WaveBlockKind.TodoList),
    },
    {
      id: "gallery",
      title: "Galleria",
      subtitle: "Immagini e commenti",
      glyph: "▦",
      kind: WaveBlockKind.Gallery,
      action: () => onInsertBlock(WaveBlockKind.Gallery),
    },
    {
      id: "file",
      title: "Allegato",
      subtitle: "Carica un file",
      glyph: "📎",
      action: onPickFile,
    },
    {
      id: "heading",
      title: "Titolo",
      subtitle: "Sezione o intestazione",
      glyph: "H",
      kind: WaveBlockKind.Heading,
      action: () => onInsertBlock(WaveBlockKind.Heading),
    },
    {
      id: "decision",
      title: "Decisione",
      subtitle: "Sì / No o scelte",
      glyph: "⑂",
      kind: WaveBlockKind.Decision,
      action: () => onInsertBlock(WaveBlockKind.Decision),
    },
    {
      id: "signoff",
      title: "Sign-off",
      subtitle: "Approvazione team",
      glyph: "✍",
      kind: WaveBlockKind.Signoff,
      action: () => onInsertBlock(WaveBlockKind.Signoff),
    },
  ];

  return (
    <div className="wave-widget-picker" role="dialog" aria-label="Inserisci widget">
      <h3 className="wave-widget-picker-title">Inserisci widget</h3>

      {showDraftActions && (
        <div className="wave-widget-picker-draft">
          {trimmed.length > 0 && !trimmed.startsWith("/") && (
            <button type="button" className="wave-widget-picker-draft-btn" onClick={onAddPlainText}>
              Aggiungi come testo
            </button>
          )}
          {trimmed.toLowerCase().includes("@assistente") && (
            <button type="button" className="wave-widget-picker-draft-btn" onClick={onAddAssistant}>
              Invoca assistente
            </button>
          )}
          {trimmed.toLowerCase().includes("@documenti:") && (
            <button type="button" className="wave-widget-picker-draft-btn" onClick={onAddAssistant}>
              Chiedi ai documenti
            </button>
          )}
        </div>
      )}

      <div className="wave-widget-picker-grid">
        {options.map((opt) => (
          <button
            key={opt.id}
            type="button"
            className="wave-widget-picker-card"
            onClick={opt.action}
          >
            <span
              className="wave-widget-picker-card-icon"
              style={
                opt.kind != null
                  ? { color: blockKindColor(opt.kind) }
                  : undefined
              }
              aria-hidden
            >
              {opt.glyph}
            </span>
            <span className="wave-widget-picker-card-title">{opt.title}</span>
            <span className="wave-widget-picker-card-sub">{opt.subtitle}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
